/**
 * Configuration Redux Slice
 * Manages global configuration state using Redux Toolkit
 */

import { createSlice } from "@reduxjs/toolkit";

/**
 * Initial configuration state
 * @type {Object}
 */
const initialState = {
  clientConfig: null,
};

/**
 * Redux slice for configuration management
 * Provides actions and reducers for updating client configuration
 * @type {import("@reduxjs/toolkit").Slice}
 */
const configSlice = createSlice({
  name: "config",
  initialState,
  /**
   * Reducer functions for configuration state management
   * @property {Function} setConfig - Updates the client configuration state
   */
  reducers: {
    /**
     * Sets the client configuration
     * @param {Object} state - Current redux state
     * @param {Object} action - Redux action containing new configuration
     */
    setConfig: (state, action) => {
      state.clientConfig = action.payload;
    },
  },
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;
